import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  Modal,
  Typography,
} from "@mui/material";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { modalBoxStyle } from "../styles";

const EditSectionsModal = ({
  isOpen,
  toggleModalOpen,
  sections,
  onDeleteSection,
  isDeleting,
}) => {
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [deletingId, setDeletingId] = useState(null);

  const handleClose = () => {
    setConfirmDeleteId(null);
    setDeletingId(null);
    toggleModalOpen();
  };

  const handleDeleteClick = (sectionId) => {
    setConfirmDeleteId(sectionId);
  };

  const handleConfirmDelete = (section) => {
    setDeletingId(section.id);
    setConfirmDeleteId(null);
    onDeleteSection(section);
  };

  const handleCancelDelete = () => {
    setConfirmDeleteId(null);
  };

  return (
    <Modal open={isOpen} onClose={handleClose}>
      <Box sx={modalBoxStyle}>
        <Grid
          container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Grid item>
            <Typography variant="h2">Edit Sections</Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={handleClose}>
              <CloseOutlinedIcon />
            </IconButton>
          </Grid>
        </Grid>
        <Box sx={{ marginTop: 4 }}>
          {sections?.length > 0 ? (
            <List>
              {sections.map((section) => (
                <ListItem
                  key={section.id}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid",
                    borderColor: (theme) => theme.palette.terrain[300],
                    paddingY: 2,
                  }}
                >
                  <Typography variant="body1">{section.name}</Typography>
                  {confirmDeleteId === section.id ? (
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        disabled={isDeleting}
                        onClick={() => handleConfirmDelete(section)}
                        sx={{ borderRadius: 2 }}
                      >
                        <Typography variant="smallButton">Confirm</Typography>
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={handleCancelDelete}
                        sx={{ borderRadius: 2 }}
                      >
                        <Typography variant="smallButton">Cancel</Typography>
                      </Button>
                    </Box>
                  ) : deletingId === section.id ? (
                    <CircularProgress size={24} />
                  ) : (
                    <IconButton
                      onClick={() => handleDeleteClick(section.id)}
                      disabled={isDeleting}
                    >
                      <DeleteOutlineOutlinedIcon
                        sx={{
                          color: (theme) => theme.palette.error[900],
                        }}
                      />
                    </IconButton>
                  )}
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body1" sx={{ textAlign: "center", paddingY: 4 }}>
              No sections have been created for this area.
            </Typography>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default EditSectionsModal;
